import React from 'react';
// @ts-ignore
import {Link} from "react-router-dom";
import styled from "styled-components";

import Colors from "../../assets/colors/Colors";
import SocialMediaHeader from "../defaultLayout/MainHeader/HeaderComponents/SocialMediaHeader";
import Constants from "../../data/Constants";
import {RowDiv} from "../../components/styledComponents/CustomStyledComponents";
import Images from "../../assets/images/Images";
import HomeSideBar from "./HomeSideBar";


const CloseSideBarIcon: React.FC = () => {
    return(
        <div style={{flex: 2}}>
            <Link to={Constants.routes.economicResearch} id='navbarIcon'>
                <img src={Images.close} style={{height: 30, filter: 'brightness(0) invert(1)'}}/>
            </Link>
        </div>
    )
};

const HomeSidebarDiv = styled.div`
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    height: 100%;
    padding: 50px;
    width: 20vw;
    min-width: 300px;
    background-color: ${Colors.sidebarNavigationRed};
`;

const ChildrenWrapper = styled.div`
    height: 100%;
    flex: 1 1 auto;
`;

const HomeComponent: React.FC = ({children}) => {
    return (
        <RowDiv style={{height: '100%'}}>
            <ChildrenWrapper id='ChildrenWrapper'>
                {children}
            </ChildrenWrapper>
        </RowDiv>

    );
};

export default HomeComponent;
